/** Tabs the panel shows. The chat tab is the conversation itself, so it is not listed here. */ export const panelTabs = (state)=>state.tabs.filter((tab)=>tab.tabKind === 'PANEL').sort((a, b)=>a.position - b.position);
export const widgetsForTab = (state, tabId)=>state.widgets.filter((widget)=>widget.tabId === tabId).sort((a, b)=>a.position - b.position);
/**
 * Decides what a widget shows. Only READY widgets with a catalog render URL mount a frame.
 * STAGED widgets wait; anything else is unavailable with a reason, never a blank frame.
 */ export const resolveWidgetView = (widget, catalog)=>{
    var _catalog_find;
    if (widget.status === 'STAGED') {
        return {
            kind: 'staged'
        };
    }
    if (widget.status !== 'READY') {
        return {
            kind: 'unavailable',
            reason: 'status'
        };
    }
    // Prefer exact app+version pin; fall back to same componentId on a newer install.
    const component = (_catalog_find = catalog.find((candidate)=>candidate.componentId === widget.componentId && String(candidate.appVersionId) === widget.appVersionId)) !== null && _catalog_find !== void 0 ? _catalog_find : catalog.find((candidate)=>candidate.componentId === widget.componentId);
    if (!component) {
        return {
            kind: 'unavailable',
            reason: 'not_in_catalog'
        };
    }
    if (!component.renderUrl) {
        return {
            kind: 'unavailable',
            reason: 'no_render_url'
        };
    }
    return {
        kind: 'ready',
        renderUrl: component.renderUrl,
        props: widget.props
    };
};
